
import track from "./track";
export default {
    data() {
        return {
            init: false,
            companies: [],
            powerPrices: [],
            selectedCompany: -1,
            locale: 'en',
            cups: null, //'ES0031408178313007VV0F',
            data: null,
            fullData: null,
            errors: null,
            errorsCups: null,
            loading: false,
            disabledButton: true,
            hiddenButton: false,
            view: '',
            manualStep: 0,
            rate: null,
            manualForm: {
                'startDate': null,
                'endDate': null,
                'power1': 4.4,
                'power2': 4.4,
                'consumption1': null,
                'consumption2': null,
                'consumption3': null,
                'price': null,
            },
            manualFormErrors: {
                'startDate': false,
                'endDate': false,
                'power1': false,
                'consumption1': false,
                'consumption2': false,
                'consumption3': false,
                'price': false,
                'company':false,
            },
            today: Date.now(),
            showPrice: false,
        }
    },
    mounted: function () {
        this.locale = document.getElementsByTagName('html')[0].getAttribute('lang');
        this.companies = JSON.parse(document.getElementById('myData').getAttribute('data-page'));
        this.today = new Date().toISOString().slice(0, 10);
        let value = 2.0;
        while (value < 14.9) {
            this.powerPrices.push(value.toFixed(1));
            value = value + 0.1;
        }
        // special prices
        this.powerPrices.push(3.45);
        this.powerPrices.push(3.464);
        this.powerPrices.push(5.196);
        this.powerPrices.push(5.75);
        this.powerPrices.push(6.928);
        this.powerPrices.push(8.05);
        this.powerPrices.push(10.35);
        this.powerPrices.push(10.392);
        this.powerPrices.push(13.856);
        this.powerPrices.push(14.49);

        this.powerPrices.sort(function (a, b) { return a - b; });

    },
    methods: {
        selectCompany(val) {
            this.selectedCompany = val;
        },
        changeCalculatorType(val) {
            if (val === this.view) {
                this.view = '';
            } else {
                this.view = val;
            }
            this.data = null;
            this.errors = null;
        },
        async getCalculatorManual() {
            if (!this.manualValidator()) {
                return;
            }

            this.data = { 'ca': 'Estem calculant, espera un moment si us plau', 'es': 'Estamos calculando, espera un momento por favor' };
            this.loading = true;

            const res = await axios.get('/api/v1/energy/manualCalculator',
                {
                    params: {
                        cups: this.cups,
                        company: this.selectedCompany,
                        startDate: this.manualForm.startDate,
                        endDate: this.manualForm.endDate,
                        power1: this.manualForm.power1,
                        power2: this.manualForm.power2,
                        power3: this.manualForm.power3,
                        consumption1: this.manualForm.consumption1,
                        consumption2: this.manualForm.consumption2,
                        consumption3: this.manualForm.consumption3,
                        price: this.manualForm.price,
                        lang: this.locale
                    }
                },
                { timeout: 10000 }
            );

            const response = res['data'];


            this.loading = false;
            this.data = null;

            if (!response.status) {
                this.errors = response.reason;
                this.hiddenButton = false;
                this.view = 'manual'
                // Analytics
                track.event({
                    eventCategory: "energy",
                    eventAction: "calculator",
                    eventLabel: response?.reason ?? "UNKNOWN"
                })
            } else {
                this.errors = null;
                this.hiddenButton = true;

                this.data = parseFloat(response.data).toFixed(2);
                this.fullData = response.fullData;

                if(this.manualForm.price !== null) {
                    this.fullData.old_total = this.manualForm.price;
                    this.fullData.saved_total = this.manualForm.price - this.fullData.total;
                }

                // Analytics
                track.event({
                    eventCategory: "energy",
                    eventAction: "calculator",
                    eventLabel: response ?? "UNKNOWN"
                })
            }
        },
        async cupsValidator() {
            if (this.cups.length < 19) {
                if (this.locale === 'es') {
                    this.errors = "El codigo cups és de mínimo 20 caracteres";
                } else {
                    this.errors = "El codi CUPS, és de mínim 20 caràcters";
                }
                return;
            }

            const res = await axios.get('/api/v1/energy/validateCups',
                { params: { cups: this.cups, lang: this.locale } },
                { timeout: 10000 }
            );
            if (res['data']['valid'] === false) {
                if (this.locale === 'es') {
                    this.errors = "Codigo incorrecto, revisa los numeros o llamanos al telefono gratuito 800 678 010 i te ayudaremos.";
                } else {
                    this.errors = "Codi incorrecte, revisa els números o truca'ns al telèfon gratuït 800 678 010 i t'ajudarem.";
                }
                return false;
            }
            this.cups = res['data']['cups'];
            return true;
        },
        async getCalculator() {
            if (!(await this.cupsValidator())) {
                return;
            }

            this.data = { 'ca': 'Estem calculant, espera un moment si us plau', 'es': 'Estamos calculando, espera un momento por favor' };
            this.loading = true;
            this.errors = null;

            const res = await axios.get('/api/v1/energy/calculator',
                { params: { cups: this.cups, lang: this.locale } },
                { timeout: 10000 }
            );
            const response = res['data'];

            this.loading = false;
            this.data = null;

            if (!response.status) {
                this.hiddenButton = false;
                this.view = 'manual'

                if(response.reason === 'ko-not2x') {
                    this.errorsCups = response.message;
                } else {
                    if (this.locale === 'es') {
                        this.errorsCups = "No hemos podido hacer el cálculo automático. Necesitamos más datos para poder calcular tu precio.";
                    } else {
                        this.errorsCups = "No hem pogut fer el càlcul automàtic. Necessitem més dades per poder calcular el teu preu.";
                    }
                }
                // Analytics
                track.event({
                    eventCategory: "energy",
                    eventAction: "calculator",
                    eventLabel: response?.reason ?? "UNKNOWN"
                })
            } else {
                this.errors = null;
                this.hiddenButton = true;

                this.data = parseFloat(response.data).toFixed(2);

                // Analytics
                track.event({
                    eventCategory: "energy",
                    eventAction: "calculator",
                    eventLabel: response ?? "UNKNOWN"
                })
            }
        },
        manualValidator() {
            // console.log(!this.manualForm.startDate);
            // console.log(!this.manualForm.endDate);
            // console.log(!this.manualForm.power1);
            // console.log('aaaaa');
            // console.log(this.juneValidator());
            // console.log('juny is validated');
            // console.log(!this.manualForm.consumption1);
            // console.log(!this.manualForm.price);
            // console.log(this.selectedCompany === -1);
            if (!this.manualForm.startDate || !this.manualForm.endDate
                || !this.manualForm.power1 || !this.manualForm.consumption1
                || !this.manualForm.price || this.selectedCompany === -1
                || this.juneValidator() === false)
            {
                this.startDateValidator();
                this.endDateValidator();
                this.power1Validator();
                this.consumption1Validator();
                this.priceValidator();
                this.companyValidator();
                this.juneValidator();

                if (this.locale === 'es') {
                    this.errors = 'Por favor, rellena todos los campos obligatorios';
                } else {
                    this.errors = 'Si us plau, omple tots els camps obligatoris';
                }

                return false;
            }
            this.errors = null;

                this.startDateValidator();
                this.endDateValidator();
                this.power1Validator();
                this.consumption1Validator();
                this.priceValidator();
                this.companyValidator();
                this.juneValidator();

            return true;
        },
        juneValidator() {
                const startDate = new Date(this.manualForm.startDate);
                const endDate = new Date(this.manualForm.endDate);

                if((startDate.getMonth() >= 5 && startDate.getFullYear() > 2020)|| (endDate.getMonth() >= 5 && endDate.getFullYear() > 2020 )) {
                    this.consumption2Validator();
                    this.consumption3Validator();
                    if(this.consumption2Validator() && this.consumption3Validator()) {
                        return true
                    } else {
                        return false;
                    }
                }
                return true;
        },
        companyValidator() {
            if(this.selectedCompany === -1) {
                this.manualFormErrors.company = true;
            } else {
                this.manualFormErrors.company = false;
            }
        },
        priceValidator() {
            if(!this.manualForm.price) {
                this.manualFormErrors.price = true;
            } else {
                this.manualFormErrors.price = false;
            }
        },
        startDateValidator() {
            if (!this.manualForm.startDate) {
                this.manualFormErrors.startDate = true;
            } else {
                this.manualFormErrors.startDate = false;
            }
        },
        endDateValidator() {
            if (!this.manualForm.endDate) {
                this.manualFormErrors.endDate = true;
            } else {
                this.manualFormErrors.endDate = false;
            }
        },
        power1Validator() {
            if (!this.manualForm.power1) {
                this.manualFormErrors.power1 = true;
            } else {
                this.manualFormErrors.power1 = false;
            }
        },
        consumption1Validator() {
            if (!this.manualForm.consumption1) {
                this.manualFormErrors.consumption1 = true;
            } else {
                this.manualFormErrors.consumption1 = false;
            }
        },
        consumption2Validator() {
            if (!this.manualForm.consumption2) {
                this.manualFormErrors.consumption2 = true;
                return false;
            } else {
                this.manualFormErrors.consumption2 = false;
                return true;
            }
        },
        consumption3Validator() {
            if (!this.manualForm.consumption3) {
                this.manualFormErrors.consumption3 = true;
                return false;
            } else {
                this.manualFormErrors.consumption3 = false;
                return true;
            }
        },
        isNewRate(start, end) {
            //dates are in juny 2021 period
            const startSplite = start.split('-');
            const endSplite = end.split('-');

            if (startSplite[0] >= 2021 && startSplite[1] >= 6) {
                return true;
            }

            if (endSplite[0] >= 2021 && endSplite[1] >= 6) {
                return true;
            }
            return false;
        },
        selectRate(val) {
            this.manualForm.consumption1 = null;
            this.manualForm.consumption2 = null;
            this.manualForm.consumption3 = null;

            this.rate = val;
            this.manualStep = 2;
        }
    },
    watch: {
        cups: function (val) {
            if (val.length > 19) {
                this.disabledButton = false;
            } else {
                this.disabledButton = true;
            }
            this.hiddenButton = false;
            this.data = null;
        },
        manualForm: {
            handler(val) {
                this.hiddenButton = false;
                this.data = null;
            },
            deep: true
        },
        'manualForm.startDate': function (val) {
            this.errors = null;
            const startDate = new Date(val);
            const endDate = new Date(this.manualForm.endDate)

            const diffTime = Math.abs(endDate - startDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (this.manualForm.startDate !== null && this.manualForm.endDate !== null) {
                if (startDate > Date.now() || endDate > Date.now()) {
                    this.manualStep = 0;
                    if (this.locale === 'es') {
                        this.errors = 'Las fechas son incorrectas';
                    } else {
                        this.errors = 'Les dates són incorrectes';
                    }
                    return;
                }
                else if (startDate > endDate) {
                    if (this.locale === 'es') {
                        this.errors = 'Las fechas son incorrectas';
                    } else {
                        this.errors = 'Les dates són incorrectes';
                    }
                    this.manualStep = 0;
                }
                else if (diffDays > 70) {
                    this.manualStep = 0;
                    if (this.locale === 'es') {
                        this.errors = 'Las fechas son incorrectas';
                    } else {
                        this.errors = 'Les dates són incorrectes';
                    }

                    return;
                }
                else if (val && this.manualForm.endDate) {

                    if (this.isNewRate(val, this.manualForm.endDate)) {
                        this.rate = 'new';
                        this.manualStep = 2;
                        return;
                    } else {
                        this.manualStep = 1;
                        this.rate = null;
                    }
                }

                // if ((startDate.getFullYear() === 2021 && endDate.getFullYear() === 2021) && (startDate.getMonth() < 5 && endDate.getMonth() > 2) ) {
                //     if (this.locale === 'es') {
                //         this.errors = "No podemos calcular tu tarifa con una factura entre abril y junio de 2021 (por los cambios de tarifa generales del 1 de junio).Usa cualquier otra, ¡no es necesario que sea la última!";
                //     } else {
                //         this.errors = "No podem calcular la teva tarifa amb una factura entre abril i juny de 2021 (pels canvis de tarifa generals de l'1 de juny). Fes servir qualsevol altra factura, no cal que sigui la darrera!";
                //     }
                //     this.manualStep = 0;
                //     return;
                // }
            }
        },
        'manualForm.endDate': function (val) {
            this.errors = null;

            const endDate = new Date(val);
            const startDate = new Date(this.manualForm.startDate);

            const diffTime = Math.abs(startDate - endDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (this.manualForm.startDate !== null && this.manualForm.endDate !== null) {
                if (endDate > Date.now() || startDate > Date.now()) {
                    if (this.locale === 'es') {
                        this.errors = 'Las fechas son incorrectas';
                    } else {
                        this.errors = 'Les dates són incorrectes';
                    }
                    this.manualStep = 0;
                    return;
                }
                else if (startDate > endDate) {
                    if (this.locale === 'es') {
                        this.errors = 'Las fechas son incorrectas';
                    } else {
                        this.errors = 'Les dates són incorrectes';
                    }
                    this.manualStep = 0;
                }
                else if (diffDays > 70) {
                    this.manualStep = 0;
                    if (this.locale === 'es') {
                        this.errors = 'Las fechas son incorrectas';
                    } else {
                        this.errors = 'Les dates són incorrectes';
                    }
                    return;
                }
                else if (val && this.manualForm.startDate) {

                    if (this.isNewRate(this.manualForm.startDate, val)) {
                        this.rate = 'new';
                        this.manualStep = 2;

                    } else {
                        this.manualStep = 1;
                        this.rate = null;
                    }
                }

                // if ((startDate.getFullYear() === 2021 && endDate.getFullYear() === 2021) && (startDate.getMonth() < 5 && endDate.getMonth() > 2) ) {
                //     if (this.locale === 'es') {
                //         this.errors = "No podemos calcular tu tarifa con una factura entre abril y junio de 2021 (por los cambios de tarifa generales del 1 de junio).Usa cualquier otra, ¡no es necesario que sea la última!";
                //     } else {
                //         this.errors = "No podem calcular la teva tarifa amb una factura entre abril i juny de 2021 (pels canvis de tarifa generals de l'1 de juny). Fes servir qualsevol altra factura, no cal que sigui la darrera!";
                //     }
                //     this.manualStep = 0;
                //     return;
                // }
            }

        }
    }
}
